module.exports = "<p>\r\n  customer-report works!\r\n</p>\r\n"